import fetch from 'utils/fetch';

export function usageStat(month,type) {
    const data = {
        type,
        month
    };
    return fetch({
        url: '/usageStat',
        method: 'get',
        params:data
    });
}


// WEBPACK FOOTER //
// ./src/api/usageStat.js